
import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { SERVER_ORIGIN } from "../../utilities/constants";
import css from "../../css/admin/home-page.module.css";
import userTypeModalCss from "../../css/common/user-type-modal.module.css";
import { useLocation, useSearchParams } from "react-router-dom";

const TermsAndConditionsModal = ({ show, onHide, instituteId, tabFromUrl }) => {
  const [searchParams] = useSearchParams();
  // const tabFromUrl = searchParams.get("tab");
  console.log("tabFromUrl modal>>", tabFromUrl);
  const navigate = useNavigate();


  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [termsData, setTermsData] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [mouDuration, setMouDuration] = useState("3");
  const [signDate, setSignDate] = useState("");
  // const [acceptanceDate, setAcceptanceDate] = useState(
  //   new Date().toISOString().split("T")[0]
  // );
  console.log("termsData:", termsData);
  const [acceptanceDate, setAcceptanceDate] = useState("");
  const [hasExistingDurationData, setHasExistingDurationData] = useState(false);
  const [isEMUser, setIsEMUser] = useState(false);
  const [isInstituteReadOnly, setIsInstituteReadOnly] = useState(false);
  const [isMOUApproved, setIsMOUApproved] = useState(false);
  const isInstituteTab = String(tabFromUrl || "").toLowerCase() === "institute";


  console.log("isEMUser:", isEMUser);
  console.log("hasExistingDurationData:", hasExistingDurationData);
  console.log("sfhdhgdkygdsjbdjg:", instituteId);
  console.log("isMOUApproved:", isMOUApproved);

  // Helper function to get current financial year (April to March cycle)
  const getCurrentFinancialYear = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11

    if (currentMonth >= 4) {
      // April to December - current financial year started in current calendar year
      return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
    } else {
      // January to March - current financial year started in previous calendar year
      return `${currentYear - 1}-${currentYear.toString().slice(-2)}`;
    }
  };



  useEffect(() => {
    if (!show || !instituteId) return;

    const currentPath = window.location.pathname;
    const isEMPath = currentPath.includes("/em/");
    setIsEMUser(isEMPath);
    setMouDuration("3"); // default duration
    // For institute users: sign date = today, fixed (read-only) during T&C sign
    if (!isEMPath) {
      setSignDate(new Date().toISOString().split("T")[0]);
    }

    // if (currentPath === '/em/services' ) {
    if (currentPath === "/em/services" || currentPath.includes("/em/all")) {
      // 🔁 ONLY call this API
      (async () => {
        try {
          const response = await fetch(
            `${SERVER_ORIGIN}/api/institute/auth/check-terms-chapter-em`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "auth-token": sessionStorage.getItem("token"),
              },
              body: JSON.stringify({ _id: instituteId }),
            }
          );

          if (!response.ok) {
            throw new Error("Failed to check EM terms");
          }

          const result = await response.json();
          console.log("check-terms-chapter-em result:", result);

          // Check if duration data already exists
          if (result.data?.mouDuration) {
            setMouDuration(result.data.mouDuration);
            setHasExistingDurationData(true);
          }

          if (result.data?.termsAcceptanceDate) {
            const acceptedDateValue = new Date(result.data.termsAcceptanceDate)
              .toISOString()
              .split("T")[0];
            setAcceptanceDate(acceptedDateValue);
          }
          if (result.data?.signDate) {
            const signDateValue = new Date(result.data.signDate)
              .toISOString()
              .split("T")[0];
            setSignDate(signDateValue);
          }
          // ✅ Set checkbox based on termsAccepted
          if (typeof result.data?.termsAccepted === "boolean") {
            setTermsAccepted(result.data.termsAccepted);
          }
          // Step 2: Fetch current terms for EM
          const currentFinancialYear = getCurrentFinancialYear();
          // const emId = sessionStorage.getItem('_id');
          const emId = currentPath.includes("/em/all")
            ? instituteId // use prop
            : sessionStorage.getItem("_id"); // use session

          const termsResponse = await fetch(
            `${SERVER_ORIGIN}/api/terms/auth/active/${currentFinancialYear}/${tabFromUrl}`,
            {
              headers: {
                "auth-token": sessionStorage.getItem("token"),
              },
            }
          );

          if (termsResponse.ok) {
            const termsResult = await termsResponse.json();
            setTermsData(termsResult.data);
          } else if (termsResponse.status === 404) {
            setTermsData(null);
            toast.error(
              "No active Terms and Conditions found for your chapter"
            );
          } else {
            throw new Error("Failed to fetch terms and conditions");
          }
        } catch (error) {
          console.error("Error checking chapter EM terms:", error.message);
          toast.error("Failed to load EM Terms: " + error.message);
        }
      })();
    } else {
      // 🔁 Call regular terms logic
      fetchActiveTerms();
    }
  }, [show, instituteId]);

  const fetchActiveTerms = async () => {
    try {
      setLoading(true);
      const currentFinancialYear = getCurrentFinancialYear();

      // Get institute details including the EM ID (createdBy field)
      const instituteResponse = await fetch(
        `${SERVER_ORIGIN}/api/institute/auth/check-terms`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
          },
          body: JSON.stringify({ _id: instituteId }),
        }
      );

      if (!instituteResponse.ok) {
        throw new Error("Failed to fetch institute details");
      }

      const instituteResult = await instituteResponse.json();
      console.log("Institute terms: ", instituteResult);

      let emId;

      if (window.location.pathname.includes("/em/services")) {
        emId = sessionStorage.getItem("_id");
      } else if (window.location.pathname.includes("/em/all")) {
        emId = instituteId;
      } else {
        emId = instituteResult.data?.createdBy;
      }

      console.log("Institute terms: ", instituteResult);

      // ✅ Autofill MOU Duration and Signing Date if available
      if (instituteResult.data?.mouDuration) {
        setMouDuration(instituteResult.data.mouDuration);
        setHasExistingDurationData(true);
      }

      if (instituteResult.data?.termsAcceptanceDate) {
        const signDateValue = new Date(instituteResult.data.termsAcceptanceDate)
          .toISOString()
          .split("T")[0];
        setAcceptanceDate(signDateValue);
      }

      if (instituteResult.data?.signDate || instituteResult.data?.latestMouSignDate) {
        const signDateValue = new Date(instituteResult.data.signDate || instituteResult.data.latestMouSignDate)
          .toISOString()
          .split("T")[0];
        setSignDate(signDateValue);
      }

      // ✅ Set checkbox based on termsAccepted
      if (typeof instituteResult.data?.termsAccepted === "boolean") {
        setTermsAccepted(instituteResult.data.termsAccepted);
      }

      if (typeof instituteResult.data?.isMOUapproved === "boolean") {
        setIsMOUApproved(instituteResult.data.isMOUapproved);
      }

      if (
        instituteResult.data?.termsAccepted &&
        instituteResult.data?.isThalir !== undefined
      ) {
        // ✅ User is Institute and already accepted
        setIsInstituteReadOnly(true);
      }

      if (!emId) {
        const chapterName = instituteResult.data?.chapterName;
        const instituteName = instituteResult.data?.name;

        if (chapterName) {
          throw new Error(
            `No Chapter EM found for "${chapterName}". Please contact your administrator to set up Terms & Conditions for your chapter.`
          );
        } else {
          throw new Error(
            `Institute "${instituteName}" is not linked to any Chapter EM. Please contact administrator.`
          );
        }
      }

      // Fetch active terms for this EM and financial year
      const termsResponse = await fetch(
        `${SERVER_ORIGIN}/api/terms/auth/active/${currentFinancialYear}/${tabFromUrl}`,
        {
          headers: {
            "auth-token": sessionStorage.getItem("token"),
          },
        }
      );

      if (termsResponse.ok) {
        const termsResult = await termsResponse.json();
        setTermsData(termsResult.data);
      } else if (termsResponse.status === 404) {
        setTermsData(null);
        toast.error("No active Terms and Conditions found for your chapter");
      } else {
        throw new Error("Failed to fetch terms and conditions");
      }
    } catch (error) {
      console.error("Error fetching terms:", error.message);
      toast.error("Failed to load Terms and Conditions: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAcceptTerms = async () => {
    if (!termsAccepted) {
      toast.error("Please accept the Terms and Conditions to proceed");
      return;
    }

    if (!mouDuration) {
      toast.error("Please enter the MOU duration");
      return;
    }

    try {
      setLoading(true);

      const currentPath = window.location.pathname;
      const isEMServiceOrAll =
        currentPath.includes("/em/services") || currentPath.includes("/em/all");

      const postUrl = isEMServiceOrAll
        ? `${SERVER_ORIGIN}/api/em/auth/save-terms-acceptance-chapter` // ✅ For EMs
        : `${SERVER_ORIGIN}/api/institute/auth/save-terms-acceptance`; // ✅ For institutes

      const payload = {
        _id: currentPath.includes("/em/services")
          ? sessionStorage.getItem("_id") // ✅ For /em/services only
          : instituteId, // ✅ For /em/all and default
        termsAccepted: true,
        termsId: termsData?._id,
        mouDuration: mouDuration,
        ...(signDate && { signDate }), // only include if user selected
        ...(acceptanceDate && { acceptanceDate }), // only include if user selected
      };

      const response = await fetch(postUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to save terms acceptance");
      }

      toast.success("Terms and Conditions accepted successfully!");
      // onHide();
      window.location.reload();
    } catch (error) {
      console.error("Error accepting terms:", error.message);
      toast.error("Failed to accept Terms and Conditions");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setTermsAccepted(false);
    setMouDuration("3");
    setSignDate(null);
    // setAcceptanceDate(new Date().toISOString().split("T")[0]);
    setAcceptanceDate(null);
    setHasExistingDurationData(false);
    onHide();
  };

  // Determine if inputs should be disabled
  const shouldDisableInputs = isEMUser && hasExistingDurationData;
  console.log("shouldDisableInputs:", shouldDisableInputs);

  const isThalirTab = String(tabFromUrl || "").toLowerCase() === "thalir";
  const durationOptions = isThalirTab ? ["3"] : ["1", "2", "3"];
  useEffect(() => {
    if (isThalirTab) {
      setMouDuration("3"); // force THALIR duration
    }
  }, [isThalirTab]);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="terms-modal-title"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="terms-modal-title">Terms and Conditions</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="text-center p-4">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading Terms and Conditions...</p>
          </div>
        ) : !termsData ? (
          <div className="text-center p-4">
            <div className="alert alert-warning">
              <h5>No Active Terms and Conditions Found</h5>
              <p>
                There are currently no active Terms and Conditions available for
                your chapter. Please contact your Chapter EM or administrator.
              </p>
            </div>
          </div>
        ) : (
          <div>
            {/* Terms Content Display */}
            <div className="mb-4">
              <h5>{termsData.title}</h5>
              <p className="text-muted">
                Financial Year: {termsData.financialYear}
              </p>
              <div
                className="border p-3 mb-3"
                style={{ maxHeight: "300px", overflowY: "auto" }}
                dangerouslySetInnerHTML={{ __html: termsData.content }}
              />
            </div>

            {/* Show message if inputs are disabled for EM user */}
            {shouldDisableInputs && (
              <div className="alert alert-info mb-3">
                <i className="bi bi-info-circle"></i> Duration data already
                exists. Only the duration field can be updated.
              </div>
            )}

            {/* Acceptance Form */}
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Terms Duration (Years) *</Form.Label>
                    {/* <Form.Select
                      value={mouDuration}

                      onChange={(e) => setMouDuration(e.target.value)}
                      disabled={
                        isThalirTab ||
                        (!isInstituteTab && shouldDisableInputs) ||
                        (!isInstituteTab && isInstituteReadOnly)
                      }
                    >
                      {durationOptions.map((yr) => (
                        <option key={yr} value={yr}>
                          {yr} Year{yr === "3" ? "" : "s"}
                        </option>
                      ))}
                    </Form.Select> */}
                    <Form.Select
                      value={mouDuration}
                      onChange={(e) => setMouDuration(e.target.value)}
                      disabled={
                        isThalirTab ||          // THALIR → always disabled (fixed 3)
                        shouldDisableInputs ||  // Existing data → disabled
                        isInstituteReadOnly     // Institute already accepted → disabled
                      }
                    >
                      <option value="3">3 Years</option>
                      <option value="2">2 Years</option>
                      <option value="1">1 Year</option>
                    </Form.Select>
                    <Form.Text className="text-muted">
                      {isThalirTab
                        ? "THALIR duration is fixed (3 years) unless changed by admin configuration."
                        : "Select duration (1 / 2 / 3 years). Expiry date will be calculated automatically after saving."}
                    </Form.Text>

                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Signing Date *</Form.Label>
                    <Form.Control
                      type="date"
                      value={signDate}
                      onChange={(e) => setSignDate(e.target.value)}
                      max={new Date().toISOString().split("T")[0]}
                      required
                      readOnly={!isEMUser}
                      disabled={!isEMUser || shouldDisableInputs}
                    />
                    {!isEMUser && (
                      <Form.Text className="text-muted">
                        Set automatically to today and cannot be changed.
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Acceptance Date</Form.Label>
                    <Form.Control
                      type="date"
                      value={acceptanceDate}
                      onChange={(e) => setAcceptanceDate(e.target.value)}
                      min={signDate || undefined}   // ✅ Disable dates before signing date

                      max={new Date().toISOString().split("T")[0]}
                      // readOnly
                      disabled={!isEMUser} // ✅ Disabled for non-EM users, enabled for EM users

                    // disabled={!shouldDisableInputs} // Disabled for EM users with existing data
                    />
                    {/* <Form.Text className="text-muted">
                      This is automatically set to today's date
                    </Form.Text> */}
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  id="terms-acceptance"
                  label="I hereby accept the above Terms and Conditions"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                  required
                  // disabled={shouldDisableInputs} // Disabled for EM users with existing data
                  //   disabled={isInstituteReadOnly} // 🔒
                  disabled={shouldDisableInputs || isInstituteReadOnly || isMOUApproved} // ✅ combined condition
                />
              </Form.Group>
            </Form>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>

        {/* {(!isEMUser || !acceptanceDate) && !isInstituteReadOnly && ( */}
        {/* {( acceptanceDate) && ( */}
        <Button
          variant="primary"
          onClick={handleAcceptTerms}
          disabled={loading || !termsAccepted}
        >
          {loading ? "Processing..." : "Accept Terms & Conditions"}
        </Button>
        {/* )} */}
      </Modal.Footer>
    </Modal>
  );
};
const TermsAndConditionsButton = ({
  instituteId,
  text = "View Terms & Conditions",
  isAccepted = false,
  onAccept = null,
  tabFromUrl = null, // Add this prop
  disabled = false   // ✅ add this

}) => {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    if (!isAccepted && onAccept) {
      // If terms are not accepted and we have an accept handler
      setShowModal(true);
    } else {
      // Just view terms
      setShowModal(true);
    }
  };

  const buttonText = isAccepted ? "View Terms & Conditions" : "Accept Terms";

  return (
    <>
      <Button
        variant={isAccepted ? "outline-primary" : "primary"}
        size="sm"
        onClick={handleClick}
        disabled={disabled}   // ✅ add this line

        style={{
          borderColor: isAccepted ? "#0d5e9c" : "#2f80ed",
          backgroundColor: isAccepted ? "transparent" : "#2f80ed",
          color: isAccepted ? "#0d5e9c" : "white",
          fontSize: "12px",
          padding: "4px 8px",
        }}
      >
        {buttonText}
      </Button>

      <TermsAndConditionsModal
        show={showModal}
        onHide={() => setShowModal(false)}
        instituteId={instituteId}
        tabFromUrl={tabFromUrl} // Pass tab data to modal

      />
    </>
  );
};

export { TermsAndConditionsModal }; // optional, if you want to use the modal somewhere else
export default TermsAndConditionsButton; // ✅ this is what you import and use
